/** @file REST client for the projects browser and the export dialog: restore, purge, thumbnails, export runs. */
import type { ExportResult } from '@pose2d/api/export/exportTypes';
import type { FetchLike } from './createApiClient';
import { exportQuery, type ExportRequest } from './exportQuery';
import { requestApi } from './requestApi';
import type { ThumbResult } from './sessionTypes';

const project = (id: string): string => `/api/v1/projects/${encodeURIComponent(id)}`;

/** Restore is a `project.restore` batch and purge a session-only route (R-E7-09); export is the same tool MCP agents call (R-E7-07). */
export function createProjectsApi(fetchFn: FetchLike) {
  return {
    restore: (id: string) => requestApi(fetchFn, 'POST', `${project(id)}/commands`, { commands: [{ name: 'project.restore', input: {} }] }) as Promise<{ rev: number }>,
    purge: (id: string) => requestApi(fetchFn, 'POST', `/api/v1/session/projects/${encodeURIComponent(id)}/purge`) as Promise<{ purged: string }>,
    renderThumbnail: (id: string) => requestApi(fetchFn, 'POST', `/api/v1/session/projects/${encodeURIComponent(id)}/thumbnail`) as Promise<ThumbResult>,
    runExport: (id: string, request: ExportRequest) => requestApi(fetchFn, 'GET', `${project(id)}/export?${exportQuery(request)}`) as Promise<ExportResult>,
  };
}

/** The projects REST client (see createProjectsApi). */
export type ProjectsApi = ReturnType<typeof createProjectsApi>;
